var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{class:['header-logo', { 'is-static': _vm.isStatic }]},[_c('a',_vm._b({},'a',_vm.$attrs,false),[_c('img',{attrs:{"src":_vm.imgSrc,"alt":_vm.imgAlt,"width":_vm.imgWidth,"height":_vm.imgHeight}})])])
}]

export { render, staticRenderFns }